import { AnchorHTMLAttributes, FC, MouseEvent } from "react";
import { useNavigate } from "react-router-dom";
import { smoothScrollToElement } from "./smoothScroll";

type SectionLinkProps = AnchorHTMLAttributes<HTMLAnchorElement> & {
  // id of a home page section, e.g. "pricing"
  section: string;
};

// Glides to a home page section when it's on screen, otherwise opens the home page at it
export const SectionLink: FC<SectionLinkProps> = ({
  section,
  onClick,
  children,
  ...props
}) => {
  const navigate = useNavigate();

  const handleClick = (event: MouseEvent<HTMLAnchorElement>) => {
    onClick?.(event);
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) {
      return;
    }
    event.preventDefault();
    const target = document.getElementById(section);
    if (target) {
      window.history.replaceState(window.history.state, "", `#${section}`);
      smoothScrollToElement(target);
    } else {
      navigate(`/#${section}`);
    }
  };

  return (
    <a href={`/#${section}`} onClick={handleClick} {...props}>
      {children}
    </a>
  );
};
